/** Public school showcase tier ids (published to corporate site carousel). */
export const SHOWCASE_LEVEL_IDS = ['foundation', 'certified', 'accredited', 'flagship'];

const LEVEL_LABELS = {
  foundation: 'Foundation',
  certified: 'Certified',
  accredited: 'Global',
  flagship: 'Flagship',
  global: 'Global',
};

export function normalizeShowcaseLevel(level) {
  const k = String(level || '').toLowerCase().trim();
  if (k === 'global') return 'accredited';
  if (SHOWCASE_LEVEL_IDS.includes(k)) return k;
  return 'foundation';
}

export function showcaseLevelLabel(level) {
  const n = normalizeShowcaseLevel(level);
  return LEVEL_LABELS[n] || n;
}

export function newShowcaseEntryId() {
  return `curated-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 9)}`;
}
